import { useEffect } from "react";
import {
  React,
  Heading,
  // Steps,
  Button,
  Text,
  Shortcut,
} from "mondrian-react";

import "./style.scss";
import { handleDate, onLinkIsClicked } from "./actions.js";
// import { isMobile } from "react-device-detect";
import useIsTotem from "hooks/useIsTotem";
import { reportGA4, reportPageViewGA4 } from "utils/pushDataLayer";


const FaturaEmpty = ({ handleButtonClick, msisdn }) => {
  // const [steps] = React.useState([
  //   {
  //     title: "Celular",
  //     status: "doing",
  //   },
  //   {
  //     title: isMobile ? "Código" : "Código de segurança",
  //     status: "doing",
  //   },
  //   {
  //     title: "Faturas",
  //     status: "doing",
  //   },
  // ]);
  useEffect(() => {
    reportPageViewGA4({customTitle: 'detalhes_de_fatura'})
  }, [])
  const isTotem = useIsTotem();

  return (
    <div>
      <Heading xs className="mcm-TitleEmpty">
        Você não possui nenhuma fatura em aberto para o número {msisdn}
      </Heading>
      <Text body>Consulta realizada em {handleDate()}</Text>
      <Button onClick={() => {
        handleButtonClick()
        reportGA4({customTitle: 'detalhes_de_fatura:consultar_outro_numero'})
      }} 
      className="mcm-backButton">
        Consultar outro número
      </Button>
      {!isTotem &&
        <>
          <Heading xs className="mcm-MoreInfo">
            Para mais informações acesse os canais:
          </Heading>
          <Shortcut
            onClick={() => {
              onLinkIsClicked()
              reportGA4({customTitle: 'detalhes_de_fatura:minha_claro_movel'})
            }}
            icon={"mdn-Shortcut-icon mdn-Icon-documento mdn-Icon--md"}
            inverse
            className="mcm-Cardlink"
          >
            Minha Claro móvel
          </Shortcut>
        </>
      }
    </div>
  );
};

export default FaturaEmpty;
